// Allow iframes in content to be wrapped in responsive code
import $ from 'jquery';

export default function setupDrawers (vars){
	$('.drawer-trigger').on('click', function(e) {
        $(this).toggleClass('drawer-trigger--open').next('.drawer-body').slideToggle();
    });
}